module.exports = __webpack_public_path__ + "media/vk-sound.26f5be78.mp3";